// @flow
export const DATEFROMTO_FILTER_SET = 'reports/DATEFROMTO_FILTER_SET';
export const DATEFROMTO_FILTER_CLEAR = 'reports/DATEFROMTO_FILTER_CLEAR';
export const dateFormat = 'YYYY-MM-DD';
